import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiCallsService } from '../../../shared/services/network/api-calls.service';
import { api } from '../../../utils/endpoints';

@Component({
  selector: 'app-static-content',
  imports: [],
  templateUrl: './static-content.component.html',
  styleUrl: './static-content.component.scss',
  encapsulation: ViewEncapsulation.Emulated, // Default
})
export class StaticContentComponent implements AfterViewInit {
  activePath: string = '';
  content = {
    title: '',
    description: '',
  };
  @ViewChild('contentFrame', { static: true }) contentFrame!: ElementRef;

  constructor(
    private _router: Router,
    private _apiService: ApiCallsService,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._activatedRoute.url.subscribe((urls) => {
      if (urls.length > 0) {
        this.activePath = urls[urls.length - 1].path;
        this.getContent();
      }
    });
  }
  getContent() {
    this._apiService.get(api._pageById + this.activePath).subscribe({
      next: (res: any) => {
        if (res) {
          this.content = {
            title: res.data.title,
            description: res.data.description,
          };
          this.ngAfterViewInit();
        }
      },
      error: (err: any) => {
        console.log('err', err.error?.message);
        this._router.navigate(['/404']);
      },
    });
  }
  ngAfterViewInit() {
    const iframe = this.contentFrame.nativeElement as HTMLIFrameElement;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDoc) {
      iframeDoc.open();
      iframeDoc.write(`
        <html>
          <head>
            <style>
              body { font-family:'Urbanist', sans-serif; font-size: 14px; line-height: 24px;padding:0;margin:0; color:#3A4857;letter-spacing: 0.66px; }
              ul, ol, li a,p span, i, em{font-family:'Urbanist', sans-serif;}
              html{
              height:auto}
              ul, ol{
              padding:0;
              margin:15px 0 0 0;
                  list-style-position: inside;
                  list-style-type:none;
              }
              .staticPage *{font-family:'Urbanist', sans-serif;}
              .staticPage img {
                  width: 100%;
                  max-width: 400px;
                  border-radius: 14px;
                      margin:0 0 20px 0;
                      display: block;
              }
                  .staticPage p {
                    font-size: 14px;
                    display: block;
                    margin-bottom: 20px;
                    line-height: 24px;
                    color: #3A4857;
                    line-height:24px;

                }

                h1, h2, h3, h4, h5, h6{margin:0 0 20px 0; font-family:'Urbanist', sans-serif;color: #2C2929;font-weight:600;}

                .staticPage h1 {
                      font-size: 32px;
                      line-height: 36px;
                  }
                      .staticPage h2 {
                      font-size: 24px;
                       line-height: 28px;
                  }
                      .staticPage h3 {
                      font-size: 18px;
                       line-height: 22px;
                  }
                      .staticPage h4 {
                      font-size: 16px;
                       line-height: 20px;
                  }
                      .staticPage h5 {
                      font-size: 13px;
                       line-height: 17px;
                  }
                      .staticPage h6 {
                      font-size: 10px;
                       line-height: 14px;
                  }
                  a{font-size:16px}
                  ul  li , ol li{
                      font-size:14px;
                      position:relative;
                      margin-bottom:10px;
                      padding-left:22px;
                      color: #3A4857;
                        line-height:24px;
                  }
                      blockquote{margin:0;}

                     ul li:after, ol li:after {
                         content: "";
                          position: absolute;
                          left: 0;
                          top: 2px;
                          background: url(assets/images/ic-bullet.png) no-repeat;
                          background-size: 14px;
                          width: 19px;
                          height: 19px;
                          background-position: center;
                      }



                    @media screen and (max-width:768px){
                    .staticPage h1 {
                          font-size: 24px;
                          line-height: 28px;
                      }
                      .staticPage h2 {
                          font-size: 24px;
                          line-height: 28px;
                      }

                    }

            </style>
          </head>
          <body class="staticPage">${this.content.description}</body>
        </html>
      `);
      iframeDoc.close();

      // Adjust iframe height dynamically
      setTimeout(() => {
        iframe.style.height = iframeDoc.body.scrollHeight + 'px';
      }, 100);
    }
  }
}
